<script setup>
defineProps({
  audienceGroup: {
    type: String,
    required: true,
  },
  timezoneLabelFormatted: {
    type: String,
    required: true,
  },
  isGuest: {
    type: Boolean,
    required: true,
  },
});
</script>

<template>
  <div class="calendar-timezone-audience-footer">
    <div class="calendar-timezone-footer">
      All events are displayed in {{ timezoneLabelFormatted }}
      <template v-if="!isGuest">
        <a href="/profile">Visit your profile</a> to change the time zone settings.
      </template>
    </div>
    <div class="calendar-audience-footer">
      This calendar shows a customized view of events based on your role as a
      <span class="calendar-audience-footer-audience-type">
        <span>{{ audienceGroup }}</span>
      </span>
      at the GSD.
      <template v-if="!isGuest">
        Please <a href="/profile">visit your profile</a> or the <a href="/faq">FAQ</a> page for more
        information.
      </template>
      <template v-else>
        Please visit the <a href="/faq">FAQ</a> page for more information.
      </template>
    </div>
  </div>
</template>
